import type { Map, Feature } from 'ol'
import { Layer } from 'ol/layer'
import RenderEvent from 'ol/render/Event'
import { unByKey } from 'ol/Observable'
import { getVectorContext } from 'ol/render'
import { easeOut } from 'ol/easing'
import { Fill, Stroke, Style } from 'ol/style'
import CircleStyle from 'ol/style/Circle'

import * as ol from 'ol'

export const flashFeature = (params: {
	feature: Feature
	map: Map
	duration: number
	layer: Layer
}) => {
	const { feature, map, duration, layer } = params

	const start = Date.now()
	const flashGeom = feature.getGeometry()?.clone()

	if (!flashGeom) {
		return
	}

	const listenerKey = layer.on('postrender', animate)

	function animate(event: RenderEvent) {
		const frameState = event.frameState

		if (!frameState) {
			return
		}

		const elapsed = frameState.time - start

		if (elapsed >= duration) {
			unByKey(listenerKey)
			return
		}

		const vectorContext = getVectorContext(event)
		const elapsedRatio = elapsed / duration
		// radius will be 5 at start and 30 at end.
		const rgb = `rgb(255, ${(easeOut(elapsedRatio) + 2) * 100}, ${
			(easeOut(elapsedRatio) + 1) * 50
		})`

		const style = new Style({
			stroke: new Stroke({
				color: rgb,
				lineDash: [8],
				width: 8,
			}),
			fill: new Fill({
				color: 'rgba(0, 0, 255, 0.1)',
			}),
		})

		vectorContext.setStyle(style)
		flashGeom && vectorContext.drawGeometry(flashGeom)
		// tell OpenLayers to continue postrender animation
		map.render()
	}
}
